<style src='@/resources/styles/faq.css' scoped></style>

<template>
  <main>
    <div class='inner cover'>
      <h1 class='lead'>You've got questions? <br class='not-mobile'>We got answers.</h1>
      <div class='qa'>
        <h2 class='question'>Why are there no FAQs here?</h2>
        <p class='answer'>
          Please hang tight while we finish writing our FAQs. In the meantime, you can always contact us through
          live chat (bottom right of your screen), or shoot us an email at <a href="mailto:hi@naminus.com">hi
          @naminus.com</a>
        </p> 
      </div>







      <!--
      <div class='qa'>
        <h2 class='question'>Lorem Ipsum Dolar Sit Amet</h2>
        <p class='answer'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>
      
      <div class='qa'>
        <h2 class='question'>Lorem Ipsum Dolar Sit Amet</h2>
        <p class='answer'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>
      
      <div class='qa'>
        <h2 class='question'>Lorem Ipsum Dolar Sit Amet</h2>
        <p class='answer'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>-->
    </div>
  </main>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: 'FAQsView',

    mounted() {
      this.pageLoaded(this.$route);
    },

    methods:  {
      ...mapActions(['pageLoaded'])
    }
  }
</script>
